type ObserverHandler<T> = (data: T) => void;

export default class Observer<T = void> {
  private observers: ObserverHandler<T>[] = [];

  subscribe(observer: ObserverHandler<T>): void {
    this.observers.push(observer);
  }

  unsubscribe(observer: ObserverHandler<T>): void {
    this.observers = this.observers.filter((obs) => obs !== observer);
  }

  notify(data: T): void {
    this.observers.forEach((observer) => observer(data));
  }
}